import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { mergeMap, of, take } from 'rxjs';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { Revisione53DatiBusinessSelectors } from '../../../../store/selectors/dati-business.selectors';
import { controlloEventualiDiffida30PercentoSvant, getSchedaCoopSocialiControl } from '../validators/helpers/scheda-coop-sociali-form-validators.helper';

export const setSchedaCoopSocialiCategoriaSettoreListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkServSocioSanit(form, store);
    my_SottocategoriaSezEnteSociale(form, store);
    my_CkAgricolo(form, store);
    my_CkIndustr(form, store);
    my_CkComm(form, store);
    my_CkServiz(form, store);
};

const my_CkServSocioSanit = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getSchedaCoopSocialiControl(form, 'my_CkServSocioSanit');
    control.valueChanges.pipe(withChangeDebounced(control)).subscribe((my_CkServSocioSanit) => {
        if (my_CkServSocioSanit === '0') {
            getSchedaCoopSocialiControl(form, 'my_NormodotateA').patchValue('0', { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_NormodotateA = '0';
                return myVerbaleClone;
            });
        }
    });
};

const my_SottocategoriaSezEnteSociale = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getSchedaCoopSocialiControl(form, 'my_SottocategoriaSezEnteSociale');
    control.valueChanges
        .pipe(
            withInitialValueDebounced(control),
            mergeMap((sottocategoria: string) => {
                if (!sottocategoria) return of(null);
                return store.select(Revisione53DatiBusinessSelectors.getSottocategoriaEnteSocialeSpec(sottocategoria)).pipe(take(1));
            })
        )
        .subscribe((categoria) => {
            const desc = categoria?.descrizione ?? '';
            getSchedaCoopSocialiControl(form, 'my_SottocategoriaSezEnteSocialeDesc').patchValue(desc, { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_SottocategoriaSezEnteSocialeDesc = desc;
                return myVerbaleClone;
            });
        });
};

const my_CkAgricolo = (form: FormGroup, store: Store<Revisione53State>): void => {
    listenForDiffida30(form, store, 'my_CkAgricolo');
};

const my_CkIndustr = (form: FormGroup, store: Store<Revisione53State>): void => {
    listenForDiffida30(form, store, 'my_CkIndustr');
};

const my_CkComm = (form: FormGroup, store: Store<Revisione53State>): void => {
    listenForDiffida30(form, store, 'my_CkComm');
};

const my_CkServiz = (form: FormGroup, store: Store<Revisione53State>): void => {
    listenForDiffida30(form, store, 'my_CkServiz');
};

const listenForDiffida30 = (form: FormGroup, store: Store<Revisione53State>, field: string): void => {
    const control = getSchedaCoopSocialiControl(form, field);
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe(() => {
        controlloEventualiDiffida30PercentoSvant(store);
    });
};
